<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery(0)">查询</el-button>
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
            <el-button icon="el-icon-refresh" size="mini" @click="handleQuery(1)">导出</el-button>
          </el-form-item>
        </el-form>

        <div slot="header" class="clearfix">
          <span>卡片统计</span>
        </div>

        <el-table
          border
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            prop="name"
            label="名称"
          />
          <el-table-column
            prop="num"
            label="数量"
          />
          <el-table-column
            prop="user"
            label="人数"
          />
          <el-table-column
            prop="star_rank"
            label="星级"
          />
          <el-table-column
            prop="grade"
            label="类型"
          />
        </el-table>

      </el-card>

      <el-row :gutter="12">
        <cardStat ref="cardCountStat" :k="'count'" />
      </el-row>

      <el-row :gutter="12">
        <cardStat ref="cardUserStat" :color="1" :name="'人数'" :k="'user'" :title="'卡片人数分布'" />
      </el-row>

      <!--      <el-row :gutter="12">-->
      <!--        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">-->
      <!--          <userCount ref="userCount" />-->

      <!--        </el-col>-->
      <!--        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">-->
      <!--          <buildAvg ref="buildAvg" />-->
      <!--        </el-col>-->
      <!--      </el-row>-->
    </template>
  </BasicLayout>
</template>

<script>
import { getUserCardStat } from '@/api/user/user_info'
import cardStat from '@/views/config/card-stat/components/card-stat.vue'
import { getLastDates, scientificFormat } from '@/utils'
export default {
  name: 'CardStat',
  components: {
    cardStat
  },
  data() {
    return {
      total: 0,
      loading: false,
      queryParams: {
        startDate: '',
        endDate: '',
        lang: 0
      },
      ridData: {},
      tableData: []
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(1)
    }

    this.getTables()
  },
  methods: {
    scientificFormat,
    handleQuery(isExport = 0) {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      this.getTables(isExport)
    },
    resetQuery() {
      this.queryParams.uid = ''
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getTables(isExport = 0) {
      this.queryParams.lang = 0
      if (isExport) {
        this.queryParams.lang = 1
      }
      getUserCardStat(this.queryParams).then(res => {
        if (res.code === 200) {
          if (this.queryParams.lang) {
            window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          }
          const { data, cardInfo } = res.data
          if (data.length <= 0) {
            return
          }
          this.tableData = []
          data.forEach(item => {
            this.tableData.push({
              name: cardInfo[item.cid].name,
              num: item.count,
              user: item.user,
              grade: cardInfo[item.cid].type === 2 ? '黄金卡' : '普通卡',
              star_rank: cardInfo[item.cid].star_rank
            })
          })
          this.$refs.cardCountStat.refresh(data, cardInfo)
          this.$refs.cardUserStat.refresh(data, cardInfo)
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
